const liveTomcatConfig = {
  statusBar: {
    visibility: true,
    messgae: "UnderDevelopmentStatusBand",
    color: "red"
  },
  backend: {
    url: "https://api.rebelskool.com/"
  },
  apps: {
    url: "https://apps.rebelskool.com/"
  },
  annualReport: {
    url: "https://apps.rebelskool.com/annualreport"
  },
  corp: {
    url: "https://rebelskool.com/"
  },
  annualReportWithHash: {
    url: "https://apps.rebelskool.com/#/annualreport"
  },
  SRU: {
    url: "https://apps.rebelskool.com/income-declaration-2"
  },
  NE: {
    url: "https://apps.rebelskool.com/income-declaration-1"
  },
  forAccountingCompanies: {
    url: "https://apps.rebelskool.com/for-accounting-companies"
  },
  microsoftBusinessCentral: {
    url: "https://apps.rebelskool.com/microsoft-business-central-development"
  },
  ContactUs: {
    uploadFileSizeLimit: 2
  }
};

export default liveTomcatConfig;
